import { render, staticRenderFns } from "./reduceCostHistory.vue?vue&type=template&id=155a8400&scoped=true"
import script from "./reduceCostHistory.vue?vue&type=script&lang=js"
export * from "./reduceCostHistory.vue?vue&type=script&lang=js"
import style0 from "./reduceCostHistory.vue?vue&type=style&index=0&id=155a8400&prod&lang=scss&scoped=true"
import style1 from "./reduceCostHistory.vue?vue&type=style&index=1&id=155a8400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a8400",
  null
  
)

export default component.exports